import { KitType } from '@repo/types';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';
import { usePrefetchChatbotPrompts } from 'services/chatbotPrompts/useChatbotPrompts';
import useFeature from 'services/features/useFeature';
import { ConditionMetricsList as LegacyConditionMetricsList } from './ConditionMetricsList';
import ConditionsEducationalModal from './ConditionsEducationalModal';
import { ConditionsEducationalModalProvider } from './ConditionsEducationalModal/context';
import { ConditionsDetailFlagGate } from './Details/ConditionsDetailFlagGate';
import { ConditionDetailView } from './EmergingResearch/ConditionDetailView';
import { EmergingResearch } from './EmergingResearch/EmergingResearch';
import NewConditionMetricsList from './NewConditionMetricsList';

export const ConditionsRoutes = () => {
  const { isFeatureEnabled: gutXAxisEnabled } = useFeature('gut_x_axis');
  const { isFeatureEnabled: isHAEMEnabled } = useFeature(
    'health_associations_educational_modal',
  );
  const { currentKitType } = useCurrentKitAndTinyAccount();
  usePrefetchChatbotPrompts('conditions_detail_page');

  // The gut x-axis conditions UI is stool-only; vaginal kits keep the legacy list.
  const showGutXAxis = gutXAxisEnabled && currentKitType === KitType.STOOL;

  return (
    <ConditionsEducationalModalProvider>
      {isHAEMEnabled ? <ConditionsEducationalModal /> : null}
      <Routes>
        <Route path={``} key='conditions' element={<Navigate to='metrics' />} />
        <Route
          path={`metrics`}
          key='conditions-metrics'
          element={
            showGutXAxis ? (
              <NewConditionMetricsList />
            ) : (
              <LegacyConditionMetricsList />
            )
          }
        />
        <Route
          path={`emerging-research`}
          key='conditions-emerging-research'
          element={<EmergingResearch />}
        />
        <Route
          path={`:condition`}
          key='conditions-detail'
          element={<ConditionDetailView />}
        />
        <Route
          path={`metrics/:condition`}
          key='conditions-metrics-detail'
          element={<ConditionsDetailFlagGate />}
        />
      </Routes>
    </ConditionsEducationalModalProvider>
  );
};
